export const MOBILE_NAV_CONTENT = {
  DEFAULT: 0,
  DASHBOARD: 1,
  DIRECTORY: 2,
  PROFILE: 3,
  TENDERS: 4,
  CONTENT_LIBRARY: 5
};
